// @ts-nocheck
import { useState, useEffect, useRef, useReducer } from 'react';
import { Dialog } from "primereact/dialog";
import { ListBox } from 'primereact/listbox';
import { TabView, TabPanel } from 'primereact/tabview';
import { Toast } from 'primereact/toast';
import { Button } from 'primereact/button';
import { Layer3DOption } from './Layer3DInfo/Layer3DOption';
import { TerrainSiderComponents } from './TerrainSiderComponents';
import "../assets/functionalComponents/_dialog.scss"
import "../assets/functionalComponents/_dataItem.scss"

export const Layer3DList = (props) => {
    const [selectedlayer, setSelectedlayer] = useState([]);
    const [layerList, setLayerList] = useState([
        {
            label: '傾斜攝影圖層', code: 'PhotogrammetryModel',
            items: []
        },
        {
            label: '模型圖層', code: 'Model',
            items: []
        },
        {
            label: '模型集圖層', code: 'ModelSet',
            items: []
        },
        {
            label: '點雲圖層', code: 'PointCloud',
            items: []
        },
        {
            label: '管線圖層', code: 'Pipeline',
            items: []
        },
        {
            label: '虛實整合攝影機圖層', code: 'Projector',
            items: []
        },
        {
            label: 'OGCI3S圖層', code: 'OGCI3S',
            items: []
        },
        {
            label: 'OGC3DTiles圖層', code: 'OGC3DTiles',
            items: []
        }
    ]);
    const [layerListCount, setLayerListCount] = useState(0);
    const [activeIndex, setActiveIndex] = useState(0);
    const [, forceUpdate] = useReducer(num => num + 1, 0);
    const toast = useRef(null);
    const dialogFuncMap = {
        'PhotogrammetryModel': 0,
        'Model': 1,
        'ModelSet': 2,
        'PointCloud': 3,
        'Pipeline': 4,
        'Projector': 5,
        'OGCI3S': 6,
        'OGC3DTiles': 7
    }

    useEffect(() => {
        let layers = window.LAYER_GROUP_3DMODEL.LAYER;
        let List = layerList;
        layers.forEach((layer) => {
            (List[dialogFuncMap[layer.TYPE]].items).push(layer);
        })
        setLayerListCount(layers.length);
        setLayerList(List);
    }, [])

    const PhotogrammetryModelLayerOpen = (layers) => {
        let layer = layers[layers.length - 1];
        window.main.OView.addPhotogrammetryModelLayer({
            url: window.TERRAIN_SERVER.URL,
            identifier: layer.ID,
            urlTemplate: window.TERRAIN_SERVER.URLTemplate,
            token: window.TERRAIN_SERVER.TOKEN,
            callback: (e, PhotogrammetryModel) => {
                if (e) {
                    PhotogrammetryModel.goto();
                    layers[layers.length - 1].layerObject = PhotogrammetryModel;
                    toast.current.show({ severity: 'success', summary: '圖層資訊', detail: '已開啟圖層：' + layer.TITLE });
                    setSelectedlayer(layers);
                    forceUpdate();
                    return;
                }
                else if (!e) {
                    toast.current.show({ severity: 'error', summary: '圖層資訊', detail: '開啟圖層失敗：' + layer.TITLE });
                    layers.splice(layers.length - 1, 1)
                    setSelectedlayer(layers);
                    forceUpdate();
                    return;
                }
            }
        });
        return;
    }
    const ModelLayerOpen = (layers) => {
        let layer = layers[layers.length - 1];
        window.main.OView.addModelLayer({
            url: window.TERRAIN_SERVER.URL,
            identifier: layer.ID,
            urlTemplate: window.TERRAIN_SERVER.URLTemplate,
            token: window.TERRAIN_SERVER.TOKEN,
            callback: (e, Model) => {
                if (e) {
                    Model.goto();
                    layers[layers.length - 1].layerObject = Model;
                    toast.current.show({ severity: 'success', summary: '圖層資訊', detail: '已開啟圖層：' + layer.TITLE });
                    setSelectedlayer(layers);
                    forceUpdate();
                    return;
                }
                else if (!e) {
                    toast.current.show({ severity: 'error', summary: '圖層資訊', detail: '開啟圖層失敗：' + layer.TITLE });
                    layers.splice(layers.length - 1, 1)
                    setSelectedlayer(layers);
                    forceUpdate();
                    return;
                }
            }
        });
        return;
    }
    const ModelSetLayerOpen = (layers) => {
        let layer = layers[layers.length - 1];
        window.main.OView.addModelSetLayer({
            url: window.TERRAIN_SERVER.URL,
            identifier: layer.ID,
            urlTemplate: window.TERRAIN_SERVER.URLTemplate,
            token: window.TERRAIN_SERVER.TOKEN,
            callback: (e, ModelSet) => {
                if (e) {
                    ModelSet.goto();
                    layers[layers.length - 1].layerObject = ModelSet;
                    toast.current.show({ severity: 'success', summary: '圖層資訊', detail: '已開啟圖層：' + layer.TITLE });
                    setSelectedlayer(layers);
                    forceUpdate();
                    return;
                }
                else if (!e) {
                    toast.current.show({ severity: 'error', summary: '圖層資訊', detail: '開啟圖層失敗：' + layer.TITLE });
                    layers.splice(layers.length - 1, 1)
                    setSelectedlayer(layers);
                    forceUpdate();
                    return;
                }
            }
        });
        return;
    }
    const PointCloudLayerOpen = (layers) => {
        let layer = layers[layers.length - 1];
        window.main.OView.addPointCloudLayer({
            url: window.TERRAIN_SERVER.URL,
            identifier: layer.ID,
            urlTemplate: window.TERRAIN_SERVER.URLTemplate,
            token: window.TERRAIN_SERVER.TOKEN,
            callback: (e, PointCloud) => {
                if (e) {
                    PointCloud.goto();
                    layers[layers.length - 1].layerObject = PointCloud;
                    toast.current.show({ severity: 'success', summary: '圖層資訊', detail: '已開啟圖層：' + layer.TITLE });
                    setSelectedlayer(layers);
                    forceUpdate();
                    return;
                }
                else if (!e) {
                    toast.current.show({ severity: 'error', summary: '圖層資訊', detail: '開啟圖層失敗：' + layer.TITLE });
                    layers.splice(layers.length - 1, 1)
                    setSelectedlayer(layers);
                    forceUpdate();
                    return;
                }
            }
        });
        return;
    }
    const PipelineLayerOpen = (layers) => {
        let layer = layers[layers.length - 1];
        window.main.OView.addPipelineLayer({
            url: window.TERRAIN_SERVER.URL,
            identifier: layer.ID,
            urlTemplate: window.TERRAIN_SERVER.URLTemplate,
            token: window.TERRAIN_SERVER.TOKEN,
            callback: (e, Pipeline) => {
                if (e) {
                    Pipeline.goto();
                    layers[layers.length - 1].layerObject = Pipeline;
                    toast.current.show({ severity: 'success', summary: '圖層資訊', detail: '已開啟圖層：' + layer.TITLE });
                    setSelectedlayer(layers);
                    forceUpdate();
                    return;
                }
                else if (!e) {
                    toast.current.show({ severity: 'error', summary: '圖層資訊', detail: '開啟圖層失敗：' + layer.TITLE });
                    layers.splice(layers.length - 1, 1)
                    setSelectedlayer(layers);
                    forceUpdate();
                    return;
                }
            }
        });
        return;
    }
    const ProjectorLayerOpen = (layers) => {
        let layer = layers[layers.length - 1];
        let _Cust = window.main.OView.addCustomLayer({
            layername: layer.TITLE
        });
        let param = {};
        param.ImageType = window.ov.PROJECTOR_IMAGE.WIDE;
        param.SrcType = window.ov.PROJECTOR_SRC.IMAGE;
        param.VideoPath = layer.VideoPath;
        param.Pos = layer.VideoPOS;
        param.V = layer.VideoV;
        param.Up = layer.VideoUP;
        // param.HFov = layer.HFov?layer.HFov:65;
        // param.VFov = layer.VFov?layer.VFov:80;
        // param.ImgW = layer.ImgW?layer.ImgW:5472; 
        // param.ImgH = layer.ImgH?layer.ImgH:3648; 
        param.Near = layer.Near ? layer.Near : 5;
        param.Far = layer.Far ? layer.Far : 1000;
        _Cust.addProjectorEntity(param);
        toast.current.show({ severity: 'success', summary: '圖層資訊', detail: '已開啟圖層：' + layer.TITLE });
        layers[layers.length - 1].layerObject = _Cust;
        let Pos = new window.Geo3DPoint(layer.VideoPOS.x, layer.VideoPOS.y, layer.VideoPOS.z);
        let V = new window.Geo3DPoint(layer.VideoV.x, layer.VideoV.y, layer.VideoV.z);
        let Up = new window.Geo3DPoint(layer.VideoUP.x, layer.VideoPOS.y, layer.VideoUP.z);
        let Camera = new window.ov.Camera(Pos, V, Up);
        window.main.OView.gotoCamera(Camera, true);
        setSelectedlayer(layers);
        forceUpdate();
    }
    const OGCI3SLayerOpen = (layers) => {
        let layer = layers[layers.length - 1];
        window.main.OView.addOGCI3SLayer({
            url: layer.URL,
            urlTemplate: window.TERRAIN_SERVER.URLTemplate,
            token: window.TERRAIN_SERVER.TOKEN,
            callback: (e, OGCI3S) => {
                if (e) {
                    OGCI3S.goto();
                    layers[layers.length - 1].layerObject = OGCI3S;
                    toast.current.show({ severity: 'success', summary: '圖層資訊', detail: '已開啟圖層：' + layer.TITLE });
                    setSelectedlayer(layers);
                    forceUpdate();
                    return;
                }
                else if (!e) {
                    toast.current.show({ severity: 'error', summary: '圖層資訊', detail: '開啟圖層失敗：' + layer.TITLE });
                    layers.splice(layers.length - 1, 1)
                    setSelectedlayer(layers);
                    forceUpdate();
                    return;
                }
            }
        });
        return;
    }
    const OGC3DTilesLayerOpen = (layers) => {
        let layer = layers[layers.length - 1];
        window.main.OView.addOGCI3SLayer({
            url: layer.URL,
            urlTemplate: window.TERRAIN_SERVER.URLTemplate,
            token: window.TERRAIN_SERVER.TOKEN,
            callback: (e, OGC3DTiles) => {
                if (e) {
                    OGC3DTiles.goto();
                    layers[layers.length - 1].layerObject = OGC3DTiles;
                    toast.current.show({ severity: 'success', summary: '圖層資訊', detail: '已開啟圖層：' + layer.TITLE });
                    setSelectedlayer(layers);
                    forceUpdate();
                    return;
                }
                else if (!e) {
                    toast.current.show({ severity: 'error', summary: '圖層資訊', detail: '開啟圖層失敗：' + layer.TITLE });
                    layers.splice(layers.length - 1, 1)
                    setSelectedlayer(layers);
                    forceUpdate();
                    return;
                }
            }
        });
        return;
    }

    const LayerOptionRemove = (layers) => {
        setSelectedlayer(layers);
        forceUpdate();
    }

    const LayerRemove = (layers) => {
        let layer = null;
        for (let i = 0; i < selectedlayer.length; i++) {
            if (selectedlayer[i] !== layers[i]) {
                layer = selectedlayer[i];
                break;
            }
        }
        window.main.OView.removeLayer(layer.layerObject);
        toast.current.show({ severity: 'success', summary: '圖層資訊', detail: '已關閉圖層：' + layer.TITLE });
        setSelectedlayer(layers);
        forceUpdate();
    }

    const layerOnChangeTemplate = {
        'PhotogrammetryModel': PhotogrammetryModelLayerOpen,
        'Model': ModelLayerOpen,
        'ModelSet': ModelSetLayerOpen,
        'PointCloud': PointCloudLayerOpen,
        'Pipeline': PipelineLayerOpen,
        'Projector': ProjectorLayerOpen,
        'OGCI3S': OGCI3SLayerOpen,
        'OGC3DTiles': OGC3DTilesLayerOpen,
        'LayerRemove': LayerRemove
    }

    const layerOnChange = (layers) => {
        if (selectedlayer.length > layers.length) {
            layerOnChangeTemplate['LayerRemove'](layers);
            return;
        }
        layerOnChangeTemplate[layers[layers.length - 1].TYPE](layers);
    }

    const layerListHeaderTemplate = (options) => {
        return (
            <Button onClick={options.onClick} className={options.className} badge={layerListCount.toString()}>
                {options.titleElement}
            </Button>
        );
    };

    const selectedLayerHeaderTemplate = (options) => {
        return (
            <Button onClick={options.onClick} className={options.className} badge={(selectedlayer.length).toString()}>
                {options.titleElement}
            </Button>
        );
    };

    const groupedItemTemplate = (options) => {
        const groupedIcon = {
            'PhotogrammetryModel': <ion-icon name="airplane"></ion-icon>,
            'Model': <ion-icon name="home"></ion-icon>,
            'ModelSet': <ion-icon name="business"></ion-icon>,
            'PointCloud': <ion-icon name="cloudy"></ion-icon>,
            'Pipeline': <ion-icon name="git-pull-request"></ion-icon>,
            'Projector': <ion-icon name="videocam"></ion-icon>,
            'OGCI3S': <ion-icon name="globe"></ion-icon>,
            'OGC3DTiles': <ion-icon name="globe"></ion-icon>
        }
        return (
            <div className="flex align-items-center country-item">
                {groupedIcon[options.code]}
                <div>{options.label}</div>
            </div>
        )
    }
    return (
        <div>
            <Toast ref={toast} />
            <Dialog header="3D圖層列表" visible={props.Layer3D} modal={false} keepInViewport={false} onHide={() => props.onHide('Layer3D')} className="layerList-Dialog">
                <TabView activeIndex={activeIndex} onTabChange={(e) => setActiveIndex(e.index)}>
                    <TabPanel header="圖層列表" headerTemplate={layerListHeaderTemplate}>
                        <TerrainSiderComponents />
                        <ListBox value={selectedlayer} options={layerList} filter multiple optionGroupTemplate={groupedItemTemplate} onChange={(e) => layerOnChange(e.value)} optionLabel="TITLE" optionGroupLabel="label" optionGroupChildren="items" />
                    </TabPanel>
                    <TabPanel header="已開啟圖層" headerTemplate={selectedLayerHeaderTemplate}>
                        <TerrainSiderComponents />
                        <Layer3DOption selectedlayer={selectedlayer} LayerOptionRemove={LayerOptionRemove} selected2Dlayer={props.selected2Dlayer} toast={toast} />
                    </TabPanel>
                </TabView>
            </Dialog>
        </div>
    );
}